import React from 'react';
import BaseClass from '../common/baseClass';

import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex, changeValues, changeMarca } from "../../redux/actions";
import { filterVMSelector } from "../../redux/selectors";

const common = require('../common/common');
const env = require("../../config.js").default;

class FilterVM extends BaseClass {
  constructor(props){
    super(props);
    this.state.marcheVM = [];
  }
  async componentWillMount(){
    this.updateStateWithStoreProps();
    var marcheVM = await common.getAppEnabledVM();
    this.setState({marcheVM: marcheVM})
  }
  componentDidMount(){
    const $ = window.$;
    function format(state) {
      if (!state.id) return state.text; // optgroup
      return '<img alt="' + state.text +'" class="icone" src="'+env.STATIC+'loghi/'+ state.id.toLowerCase() + '.png" />';
    }

    $("#select_vm").select2({
      templateResult: format,
      templateSelection: format,
      escapeMarkup: function(m) { return m; },
      language: common.getLanguage(),
      placeholder: common.getTrad("Seleziona una Marca")
    });

    $('#select_vm').on('select2:select keyup select2:unselect', (e) => {
      var nuovaMarca = $(e.target).val();
      // this.props.changeValues({filtersState:{marca:nuovaMarca, modello: ''}, renewMutex:{marcheVM: true, modelli: true, mostraImg: false, tavole: true, distinta: true, immagineTavola: true}});
      $("#erroreApplicazione").css("display", "none");
      $("#erroreTelaio").css("display", "none");
      this.props.changeMarca(nuovaMarca);
      return false;
    });
  }

  componentWillReceiveProps(nextProps){
    this.updateStateWithStoreProps(nextProps);
  }

  componentDidUpdate() {
    const $ = window.$;
    if(this.state.filtersState.marca){
      $("select#select_vm").val(this.state.filtersState.marca);
    }
    $("select#select_vm").trigger("change");
    this.updateStateWithStoreProps();
  }
  render(props){
  	return(
      <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 row-eq-height" role="alert" id="ricerca_filtro_marca">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_filtro">
          <h4>{common.getTrad("Casa costruttrice")} <figure className="svg" src={env.MENU_ICONS_PATH + (window.cc.usePersonalIcons ? window.cc.csoft : "900000") + "/menu-veicoli.svg"} title={common.getTrad("Casa costruttrice")} alt={common.getTrad("Casa costruttrice")}></figure></h4>
          <hr/>
          <div className="form-group selectSwCustom">
            <select name="select_vm" className="form-control select_marche" id="select_vm" defaultValue={this.state.filtersState.marca ? this.state.filtersState.marca : ""}>
							<option></option>
              {this.state.marcheVM.map((item, key) => {
                return (
                  <option key={key} value={item[0]}>{item[1]} </option>
                )
              })}
            </select>
          </div>
        </div>
      </div>
     )
  }
}

const mapStateToProps = state => {
  const store = filterVMSelector(state);
  return { store };
}
export default connect(mapStateToProps, {changeFilter, changeDatalist, changeMutex, changeValues, changeMarca})(FilterVM);
//export default FilterVM;
